(function () {
    'use strict';

    angular.module('app').controller('GiftCardsController', GiftCardsController);

    GiftCardsController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        'blockUI',
        '$uibModal',
        'GiftCardService',
        'LoyaltyService',
        'SelectService',
        'CouponsService',
        'LANGS',
        'BusinessService',
        'SettingsService',
        'ReceiptService',
        '$sce'
    ];

    function GiftCardsController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        blockUI,
        $uibModal,
        GiftCardService,
        LoyaltyService,
        SelectService,
        CouponsService,
        LANGS,
        BusinessService,
        SettingsService,
        ReceiptService,
        $sce
    ) {
        $scope.model = {};

        $scope.params = {
            cards: {
                page: 1,
                count: 20
            },
            coupons: {
                page: 1,
                count: 50,
                sort_field: 'gift_card_id',
                sort_order: 'desc'
            }
        };

        $scope.data = {
            cardImage: {
                src: '',
                cropped: '',
                new: false
            },
            summary: {},
            pagerLengths: [10, 20, 50, 100, 200]
        };

        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {value: 'code', text: 'code', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_dt', text: 'emission_dt', visible: true},
                    {value: 'status', text: 'Status', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'emission_type', text: 'emission_type', visible: true},
                    {value: 'emission_source', text: 'emission_source', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'redeem_dt', text: 'redeem_dt', visible: true},
                    {value: 'cancel_dt', text: 'cancel_dt', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'redeem_type', text: 'redeem_type', visible: true},
                    {value: 'redeem_agent', text: 'redeem_agent', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {value: 'user_id', text: 'Customer', visible: true},
                    {value: 'deleted_by_customer', text: 'deleted_by_customer', visible: true}
                ]
            }
        ];
        $scope.isSupportUserExternalId = false;
        var block_card_edit = blockUI.instances.get('card_edit'),
            block_card_list = blockUI.instances.get('cards_list'),
            block_card_coupon_list = blockUI.instances.get('card_coupon_list');

        $scope.isPageMode = isPageMode;

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

        $scope.multiLang = MultilanguageHelper();
        $scope.onChangeLanguage = onChangeLanguage;

        $scope.getPages = getTotalPaginatedPages;
        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformParams(function (success, response) {

            SettingsService.GetPlatformSupportedLanguages(function (success, response) {
                $scope.platformSupportedLanguagesCodes = response;
            });

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    var preLastCols = $scope.table_cols.length - 1;
                    $scope.table_cols[preLastCols].data.splice(($scope.table_cols[preLastCols].data.length - 1), 0, {
                        value: 'user_external_id',
                        text: 'Customer external id',
                        visible: true,
                        not_sortable: true
                    });
                }
            }
            initController();
        });

        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('gift_card_id')) ? 'edit' : 'show';
            } else if (isRouteMode('details')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('gift_card_id')) ? 'details' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }
            ;

            if ($scope._pageMode == 'details')
                _doDetails();
        }

        function initmultiLang() {
            $scope.multiLang.initLangs(LANGS, $rootScope.LANG);
        }

        function initController() {
            initmultiLang();
            initPageMode();
        }

        function onChangeLanguage(new_lang) {
            $scope.multiLang.selected(new_lang);
        }

        function initLocaleStrings(batch) {
            $scope.multiLang.initStrings(batch, ['public_title', 'public_description']);
        };

        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {

                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {
                        $scope.data.cardImage.new = true;
                        $scope.data.cardImage.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('cardImage'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.setDefaultGiftCardImage = function () {
            $scope.data.cardImage.new = false;
            $scope.data.cardImage.cropped = '';
            $scope.data.cardImage.src = '';
        }

        $scope.cropGiftCardImage = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.cardImage);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.cardImage = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        function getGiftCards(callback) {
            block_card_list.start();
            var params = {};

            params = angular.copy($scope.params.cards);
            params.only_active = !$scope.data.showDisabledItems;

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id)
                params.loyalty = $scope.data.currentLoyalty.id;

            GiftCardService.All(params, function (success, response) {
                if (success) {
                    $scope.data.giftCardsList = $rootScope.GIFT_CARDS[$scope.data.currentLoyalty.id].data;
                    $scope.data.summary = $rootScope.GIFT_CARDS[$scope.data.currentLoyalty.id].summary;
                    callback(true);
                } else {
                    callback(false);
                }

                block_card_list.stop();
            });
        }

        function getGiftCard(gift_card_id, callback) {
            block_card_edit.start();
            GiftCardService.Get(gift_card_id, function (success, response) {
                if (success) {
                    $scope.model.gift_card = angular.copy(response);
                    callback(true, response);
                } else {
                    $location.path('/gift-cards');
                    callback(false, response);
                }

                block_card_edit.stop();
            });
        }

        function getCoupons(callback) {
            var post_data = {
                loyalty_id: $scope.model.gift_card.loyalty_id,
                gift_card_id: $scope.model.gift_card.id,
                page: $scope.params.coupons.page,
                count: $scope.params.coupons.count,
                sort_field: $scope.params.coupons.sort_field,
                sort_order: $scope.params.coupons.sort_order
            };

            block_card_coupon_list.start();

            GiftCardService.GetCoupons(post_data, function (success, response) {
                if (success) {
                    $scope.data.couponsList = response.data;
                    $scope.data.summaryCoupons = response.summary;

                    block_card_coupon_list.stop();
                }
                callback(success, response);
            });
        }

        function getCoupon(code, callback) {
            CouponsService.GetCoupon(code, function (success, response) {
                if (success)
                    callback(true, response);
                else
                    callback(false, response);
            });
        }

        function initNewGiftCard() {
            $scope.model.new_gift_card = {
                loyalty_id: $scope.data.currentLoyalty.id,
                title: '',
                public_title: null,
                public_description: null,
                coupon_batches: [],
                customer_usage_timeout: 0,
                customer_usage_timeout_limited: false,
                random_emission_quantity: 0,
                random_emission_quantity_limited: false,
                usage_limit_quantity: 0,
                usage_limit_quantity_limited: false,
                usage_limit_per_customer: 0,
                usage_limit_per_customer_limited: false,
                validity_period_begin: moment().startOf('day').utc().toDate(),
                validity_period_end: moment().add(10, 'year').utc().toDate()
            };

            $scope.model.gift_card = angular.copy($scope.model.new_gift_card);
        }

        function handleGiftCardData() {
            if ($scope.model.gift_card.random_emission_quantity > 0)
                $scope.model.gift_card.random_emission_quantity_limited = true;

            if ($scope.model.gift_card.customer_usage_timeout > 0)
                $scope.model.gift_card.customer_usage_timeout_limited = true;

            if ($scope.model.gift_card.usage_limit_quantity > 0)
                $scope.model.gift_card.usage_limit_quantity_limited = true;

            if ($scope.model.gift_card.usage_limit_per_customer > 0)
                $scope.model.gift_card.usage_limit_per_customer_limited = true;
        }

        function _doShow() {
            function s() {
                if ($scope.data.currentLoyalty && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_gift_cards) {
                        getGiftCards(function (success) {
                        });
                        $rootScope.TARIFF_LIMITATION.use_gift_cards = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.use_gift_cards = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function _doDetails() {
            $scope.data.currentGiftCardId = $routeParams.gift_card_id;

            if ($scope.data.giftCardsList && $scope.data.giftCardsList.length > 0)
                $scope.model.gift_card = itemByIndex($scope.data.giftCardsList, $scope.data.currentGiftCardId);

            getGiftCard($scope.data.currentGiftCardId, function (success, response) {
                if (success) {
                    if (!$scope.data.currentLoyalty)
                        $scope.data.currentLoyalty = {id: $scope.model.gift_card.loyalty_id};

                    getCoupons(function (success, data) {
                    });
                }

            });
        }

        function _doCreate() {
            function s() {
                if ($scope.data.currentLoyalty && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.use_gift_cards) {
                        $rootScope.TARIFF_LIMITATION.use_gift_cards = false;

                        if (!$scope.model.gift_card)
                            initNewGiftCard();

                        getCouponBatchesList($scope.data.currentLoyalty.id);
                        initLocaleStrings($scope.model.gift_card);
                    } else {
                        $location.path('/gift-cards');
                        $rootScope.TARIFF_LIMITATION.use_gift_cards = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function _doEdit() {
            $scope.data.currentGiftCardId = $routeParams.gift_card_id;

            block_card_edit.start();
            getGiftCard($scope.data.currentGiftCardId, function (success, response) {
                initLocaleStrings($scope.model.gift_card);
                getCouponBatchesList($scope.data.currentLoyalty.id);
                handleGiftCardData();

                $scope.model.gift_card = dateFieldsFormat($scope.model.gift_card, 'YYYY-MM-DD');

                block_card_edit.stop();
            });
        }

        function getCouponBatchesList(lid) {
            var params = {
                page: 1,
                count: 500,
                loyalty: lid
            };

            block_card_edit.start();
            CouponsService.Batches(params, function (success, response) {
                if (success) {
                    var a = response.data;
                    $scope.data.couponBatchesList = [];
                    for (var i in a)
                        if (a[i].active === 1)
                            $scope.data.couponBatchesList.push(a[i]);

                    a = [];
                    if ($scope.model.gift_card.coupon_batches)
                        for (var i in $scope.model.gift_card.coupon_batches)
                            if (itemByIndex($scope.data.couponBatchesList, $scope.model.gift_card.coupon_batches[i].id))
                                a.push(itemByIndex($scope.data.couponBatchesList, $scope.model.gift_card.coupon_batches[i].id));

                    $scope.model.gift_card.coupon_batches = a;
                }
                block_card_edit.stop();
            });
        }

        $scope.onGiftCardSave = function (form, closeOnSave) {
            function handleResult(success, response) {
                if (success) {
                    if ($scope.data.cardImage.new) {
                        var image = $scope.data.cardImage.cropped || $scope.data.cardImage.src;
                        GiftCardService.UploadPhoto(response.id, image, function (success, upload_response) {
                            if (success) {
                                response.image = upload_response.image;

                                if (closeOnSave) {
                                    $location.path('/gift-cards');
                                }
                            }
                        });
                    } else {
                        $location.path('/gift-cards');
                    }
                    if ($scope.data.currentLoyalty.id && $rootScope.GIFT_CARDS[$scope.data.currentLoyalty.id])
                        updateItemInList($rootScope.GIFT_CARDS[$scope.data.currentLoyalty.id].data, response);
                }
                block_card_edit.stop();
            }

            if (isFormValid(form)) {
                block_card_edit.start();

                var post_data = angular.copy($scope.model.gift_card);
                post_data.loyalty_id = $scope.data.currentLoyalty.id;
                console.log('post_data', post_data);

                for (var i in post_data.coupon_batches)
                    post_data.coupon_batches[i] = {
                        id: post_data.coupon_batches[i].id,
                        title: post_data.coupon_batches[i].title
                    };

                post_data = dateFieldsFormat(post_data, 'YYYY-MM-DD[T]HH:mm:ss[Z]', 'YYYY-MM-DD');
                post_data = cleanRequestData(post_data);

                if (post_data.created) delete post_data.created;

                switch ($scope._pageMode) {
                    case 'create':
                        GiftCardService.Create(post_data, handleResult);
                        break;
                    case 'edit':
                        GiftCardService.Change($scope.data.currentGiftCardId, post_data, handleResult);
                        break;
                    default:

                }
            }
        };

        $scope.onCancelEdit = function () {
            $location.path('/gift-cards');
        };

        $scope.onGiftCardToggleClick = function (card) {
            var post_data = {
                id: card.id,
                loyalty_id: card.loyalty_id,
                active: 1 * !Boolean(card.active)
            };

            block_card_list.start();
            GiftCardService.Change(card.id, post_data, function (success, data) {
                if (success) {
                    card.active = post_data.active;
                }
                block_card_list.stop();
            });
        };

        $scope.onShareGiftCard = function (card) {
            getGiftCard(card.id, function (success, response) {
                $scope.modalGiftCardShare = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'md',
                    templateUrl: 'app/templates/modal.item.share.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.card = card;
                        for (var i in response)
                            popup.card[i] = response[i];

                        var public_title = popup.card.public_title[$rootScope.LANG];
                        var public_description = popup.card.public_description[$rootScope.LANG];
                        popup.model = {
                            share: {
                                text: public_title + ' ' + public_description + ' ',
                                tags: 'discount, sale, coupon, gift, ' + appConfig.platformParams.platform_name[$rootScope.LANG] + ', LoyaltyPays',
                                image: popup.card.image ? popup.card.image : 'assets/img/dummy_gift_card.png',
                                link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/card/show/' + card.code + '?lang=' +
                                    $rootScope.LANG
                            }
                        };

                        popup.model.share.title = public_title + ' ';
                        popup.model.share.description = public_description + ' ';

                        popup.onCopyLink = function () {
                            $scope.modalGiftCardShare.close();
                        };

                        popup.onCancelClick = function () {
                            $scope.modalGiftCardShare.close();
                        };
                    }
                });
            });
        };

        $scope.onPrintGiftCard = function (card) {
            getGiftCard(card.id, function (success, response) {
                $scope.modalGiftCardPrint = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'lg',
                    templateUrl: 'app/templates/modal.item.print.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;

                        popup.getLocalizeField = getLocalizeField;

                        popup.type = 'gift-card';
                        popup.card = card;

                        for (var i in response)
                            popup.card[i] = response[i];

                        popup.onItemPrint = function () {

                            var printContents = document.getElementById('printable-item').innerHTML,
                                canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                                canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                                popupWin = window.open('', '_blank',
                                    'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                            printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                            popupWin.document.open();
                            popupWin.document.write('<html><head><base href="/"><title></title>' +
                                '<link href="assets/print/print_item.min.css" rel="stylesheet"/></head>' +
                                '<body>' + printContents + '</body></html>');
                            popupWin.focus();

                            var count = popupWin.document.querySelectorAll('img, link').length;

                            function printOnLoad() {
                                setTimeout(function () {
                                    popupWin.focus();
                                    popupWin.document.execCommand('print');
                                    // popupWin.print();
                                    popupWin.document.close();
                                    popupWin.close();
                                }, 200);
                            }

                            if (count) {
                                popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                    el.onload = function () {
                                        if (!--count) {
                                            printOnLoad();
                                        }
                                    };
                                });
                            } else {
                                printOnLoad();
                            }
                        };

                        popup.isGiftCardExpired = function (expire_date) {
                            var ed = new Date(expire_date),
                                cd = new Date();

                            ed.setHours(0, 0, 0, 0);
                            cd.setHours(0, 0, 0, 0);

                            if (ed < cd)
                                return true;
                            else
                                return false;
                        };

                        popup.onCancelClick = function () {
                            $scope.modalGiftCardPrint.close();
                        };
                    }
                });
            });
        };

        $scope.onPrintCoupon = function (coupon) {
            var coupon_block = blockUI.instances.get('coupon_block');
            BusinessService.GetCustomPreference({name: 'coupon_paths'}, function (successSettings, data) {
                coupon_block.start();
                $scope.modalCouponPrint = $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'lg',
                    templateUrl: 'app/templates/modal.item.print.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;
                        popup.type = 'coupon';

                        var params = {
                            lang: $rootScope.LANG,
                            qr_code_link: coupon.code,
                            custom_open_link: null
                        }

                        if (successSettings && data.value) {
                            var link = data.value.coupon_path_qr;
                            if (link) {
                                link = link.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                link = link.replaceAll('{{coupon}}', coupon.code);
                                link = link.replaceAll('{{lang}}', $rootScope.LANG);
                                params.qr_code_link = link;
                            }

                            var openLink = data.value.coupon_path_share;
                            if (openLink) {
                                openLink = openLink.replaceAll('{{platform}}', appConfig.platformParams.client_site[$rootScope.LANG]);
                                openLink = openLink.replaceAll('{{coupon}}', coupon.code);
                                openLink = openLink.replaceAll('{{lang}}', $rootScope.LANG);
                                params.custom_open_link = openLink;
                            }
                        }

                        ReceiptService.getCouponView(coupon.id, params, function (success, viewData) {
                            popup.couponView = $sce.trustAsHtml(viewData.data);
                            coupon_block.stop();
                        })

                        popup.onItemPrint = function () {
                            coupon_block.start();
                            ReceiptService.getCouponPdf(coupon.id, params, function (successPdf, res) {
                                if (!successPdf) {
                                    NotifyService.Error('Can not print the receipt', true);
                                    coupon_block.stop();
                                    return;
                                }
                                var binary = atob(res.data.data.replace(/\s/g, ''));
                                var len = binary.length;
                                var buffer = new ArrayBuffer(len);
                                var view = new Uint8Array(buffer);
                                for (var i = 0; i < len; i++) {
                                    view[i] = binary.charCodeAt(i);
                                }
                                var blob = new Blob([view], {type: "application/pdf"});
                                saveAs(blob, `coupon-${coupon.id}.pdf`);
                                coupon_block.stop();
                            })
                        };

                        popup.onCancelClick = function () {
                            $scope.modalCouponPrint.close();
                        };
                    }
                });
            })
        };

        $scope.onPageChange = function (entity) {
            getGiftCards(function (success) {
            });
        };

        $scope.onChangeShowOnlyActive = function () {
            getGiftCards(function (success) {
            });
        };

        $scope.onCountChange = function (entity, count) {
            $scope.params.cards.page = 1;
            $scope.params.cards.count = count;

            getGiftCards(function (success) {
            });
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                var saved_loyalty;

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id)
                    saved_loyalty = itemByIndex($scope.data.loyaltiesList, $rootScope.ENV.filters.global_filter.loyalty_id);

                if (saved_loyalty && saved_loyalty.active === 1) {
                    $scope.data.currentLoyalty = saved_loyalty;
                } else {
                    $scope.data.currentLoyalty = getFirstActive($scope.data.loyaltiesList);
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                switch ($scope._pageMode) {
                    case 'show':
                        _doShow();

                        $rootScope.ENV.filters.gift_cards_list = {
                            loyalty_id: newValue.id
                        };

                        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                        $rootScope.storeENV();
                        break;
                    case 'create':
                        _doCreate();
                        getCouponBatchesList($scope.data.currentLoyalty.id);
                        break;
                    case 'edit':
                        _doEdit();
                        break;
                    default:

                }

            }
        }, true);
    }
})();
